import type { FC } from 'react';

import EmailIconCompass from '@crehana/compass.icons.outline/Email';
import { useTranslation } from '@crehana/i18n';
import Email from '@crehana/icons/outline/Email';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, Dialog, DialogContent, PrimaryButton } from '@crehana/ui';

import { useReportRoute } from '../RoutesReport/hooks';

const { baseLighter } = colors;

interface RoutesReportNewProps {
  isDark?: boolean;
  type: 'primary' | 'inverse';
}

const RoutesReportNew: FC<RoutesReportNewProps> = ({ isDark, type }) => {
  const { t } = useTranslation();

  const { sendReport, setReportDownloadDialog, reportDownloadDialog } =
    useReportRoute();

  const Button =
    type === 'primary'
      ? 'tw-btn-primary-xs tw-btn-icon'
      : 'tw-btn-inverse-xs tw-btn-icon';

  return (
    <>
      {/* TODO: talk with the code owner to fix this code so we can enable this rule again */}
      {/* eslint-disable-next-line react/button-has-type */}
      {/* biome-ignore lint/a11y/useButtonType: button type handled elsewhere */}
      <button className={Button} onClick={sendReport}>
        <EmailIconCompass size={20} />
        {t('SEND_REPORT')}
      </button>
      <Dialog
        className="rounded-10"
        size="s"
        isDark={isDark}
        open={reportDownloadDialog}
        onDismiss={() => setReportDownloadDialog(false)}
      >
        <DialogContent className="flex flex-col items-center justify-center">
          <Email className="mb-16" color={baseLighter} size={64} />
          <h4 className="mb-16 font-h4 text-center">
            {t('ROUTES_REPORT_TITLE')}
          </h4>
          <p className="font-body4 text-center mb-16 mx-24 indent-8">
            {t('ROUTES_REPORT_TITLE_BODY')}
          </p>
          <div className="flex items-center">
            <PrimaryButton
              label={t('ROUTES_REPORT_TITLE_BUTTON')}
              className="my-12"
              onClick={() => setReportDownloadDialog(false)}
              darkMode={isDark}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RoutesReportNew;
